import { ca } from '@cian/analytics';

interface ITrackAddFavorite {
  label: string;
  offerId: number;
}

export function trackAddFavorite({ label, offerId }: ITrackAddFavorite) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_compare',
    label,
    products: [{ id: offerId, offerType: 'offer' }],
  });
}
